import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { PonchoUIModule } from '@poncho/ui';

@Component({
    selector: 'app-outlet-change-error',
    templateUrl: './outlet-change-error.component.html',
    styleUrls: ['./outlet-change-error.component.scss'],
    standalone: true,
    imports: [MatDialogModule, PonchoUIModule]
})
export class OutletChangeErrorComponent implements OnInit {

    constructor(
        private dialogRef: MatDialogRef<OutletChangeErrorComponent>
    ) { }

    ngOnInit() {
    }

    close(data) {
        this.dialogRef.close(data);
    }

}
